export const locationData = [
    {
        loc: 'Burns Road, Karachi, Sindh',
        lat: "24.8554",
        lng: "67.0174",
        radius: "25"
    },
    {
        loc: "Liberty Market, Gulberg 3, Lahore, Punjab",
        lat: "31.5106",
        lng: "74.3445",
        radius: "25"
    },
    {
        loc: "Qissa Khawani Bazaar, Peshawar, KPK",
        lat: "34.0079",
        lng: "71.5704",
        radius: "25"
    },
    {
        loc: "Quetta, Balochistan",
        lat: "30.1798",
        lng: "66.9750",
        radius: "25"
    },
    {
        loc: "Islamabad, Capital Territory",
        lat: "33.6844",
        lng: "73.0479",
        radius: "25"
    }
];